import * as React from "react"
import { Card, CardContent, Typography } from "@mui/material"
import { Link } from "@tanstack/react-router"
import { RiArrowRightSLine } from "@remixicon/react"

import "./BasicCard.scss"
import { colors } from "@/components/colors"

export interface BasicCardProps {
  to?: string
  title: string
  children: React.ReactNode
}

export default function BasicCard({ to, title, children }: BasicCardProps) {
  return (
    <Card className="BasicCard">
      <CardContent className="Content">
        <div className="Title_div">
          <Typography className="Title">{title}</Typography>
          {to && (
            <Link to={to}>
              <RiArrowRightSLine size={18} color={`${colors.neutral.grey[600]}`} />
            </Link>
          )}
        </div>
        {children}
      </CardContent>
    </Card>
  )
}
